import BaseAPI from "../api";

const path: string = "poll-type";

export class PollTypeApi extends BaseAPI {
  static createPollType(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getPollTypeDropdown(query?: any): Promise<any> {
    return this.api.get(`${path}/dropdown`, {
      params: { ...query },
    });
  }

  static updatePollType(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deletePollType(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getPollTypeList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}